export default "__VITE_ASSET__Cu_O6Ie4__"